import type { LogContext, ILogger } from './_types';

import { useMemo } from 'react';

import { logger } from './_logger';

/**
 * Hook for using logger with component context
 */
export function useLogger(defaultContext?: LogContext): ILogger {
  return useMemo(() => {
    if (defaultContext) {
      return logger.createChild(defaultContext);
    }
    return logger;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

/**
 * Hook for component-specific logger
 */
export function useComponentLogger(componentName: string, additionalContext?: Omit<LogContext, 'component'>): ILogger {
  return useLogger({
    component: componentName,
    ...additionalContext,
  });
}
